export default {
    state: {
        active_category: null,
        active_category_name: null,
        product_category: null,

        breadcrumb: [],
        breadcrumb_default: [
            {
                text: 'Главная',
                to: {name: 'pages-index'}
            },
            {
                text: 'Каталог',
                to: {path: '/catalog'}
            }
        ],
        additional_breadcrumb: [],

        products: null,
        count: null,

        loading: true,

        prev_item: false
    },
    show_camera_type: false,
    show_matrix_size: false,
    show_lens_type: false,
    show_bayonet: false,
    show_maximum_aperture: false,
    show_focal_length: false,
    show_compatibility: false,
    show_by_temperature: false,
    show_light_type: false,
    show_LED: false,
    show_filter_brand: false,

    filter: {
        url: '/catalog',
        page: null,
        price_from: null,
        price_to: null,
        brands: [],
        camera_types: [],
        matrix_sizes: [],
        lens_types: [],
        bayonets: [],
        maximum_apertures: [],
        focal_lengths: [],
        compatibilities: [],
        by_temperatures: [],
        light_types: [],
        LEDs: [],
        sorting: null
    },

    getProducts() {
        console.log('getProducts');
        this.state.products = null;
        if (this.filter.brands && this.filter.brands.length > 0) this.show_filter_brand = true;
        else this.show_filter_brand = false;

        if (this.filter.camera_types && this.filter.camera_types.length > 0) this.show_camera_type = true;
        else this.show_camera_type = false;

        if (this.filter.matrix_sizes && this.filter.matrix_sizes.length > 0) this.show_matrix_size = true;
        else this.show_matrix_size = false;

        if (this.filter.lens_types && this.filter.lens_types.length > 0) this.show_lens_type = true;
        else this.show_lens_type = false;

        if (this.filter.bayonets && this.filter.bayonets.length > 0) this.show_bayonet = true;
        else this.show_bayonet = false;

        if (this.filter.maximum_apertures && this.filter.maximum_apertures.length > 0) this.show_maximum_aperture = true;
        else this.show_maximum_aperture = false;

        if (this.filter.focal_lengths && this.filter.focal_lengths.length > 0) this.show_focal_length = true;
        else this.show_focal_length = false;

        if (this.filter.compatibilities && this.filter.compatibilities.length > 0) this.show_compatibility = true;
        else this.show_compatibility = false;

        if (this.filter.by_temperatures && this.filter.by_temperatures.length > 0) this.show_by_temperature = true;
        else this.show_by_temperature = false;

        if (this.filter.light_types && this.filter.light_types.length > 0) this.show_light_type = true;
        else this.show_light_type = false;

        if (this.filter.LEDs && this.filter.LEDs.length > 0) this.show_LED = true;
        else this.show_LED = false;

        let url = '/api/get-products';
        axios.post(url, this.filter)
            .then(response => {
                if (response.data.products) this.state.products = response.data.products;
                else this.state.products = [];
                this.state.count = response.data.count;
                this.state.loading = false;
            })
            .catch(error => {
                if(error) this.state.loading = false;
            })
    },

    getSaleProducts() {
        this.state.products = null;
        this.show_filter_brand = false;
        this.show_camera_type = false;
        this.show_matrix_size = false;
        this.show_lens_type = false;
        this.show_bayonet = false;
        this.show_maximum_aperture = false;
        this.show_focal_length = false;
        this.show_compatibility = false;
        this.show_by_temperature = false;
        this.show_light_type = false;
        this.show_LED = false;
        let url = '/api/get-all-sale-products';
        axios.post(url, this.filter)
            .then(response => {
                if (response.data.products) this.state.products = response.data.products;
                else this.state.products = [];
                this.state.count = response.data.count;
                this.state.loading = false;
            })
            .catch(error => {
                if(error) this.state.loading = false;
            })
    },

    getBreadcrumb(parents, item, page_name) {
        this.state.additional_breadcrumb = [];

        if (parents) {
            this.state.product_category = parents;

            let item;

            if (parents.mainCategory) {
                item = null;
                item = {
                    text: parents.mainCategory.name,
                    to: {path: parents.mainCategory.url.replace(new RegExp('\/$'), '')}
                };
                // this.state.active_category_name = item.text;
                this.state.additional_breadcrumb.push(item)
            }
            if (parents.level2) {
                item = null;
                item = {
                    text: parents.level2.name,
                    to: {path: parents.level2.url.replace(new RegExp('\/$'), '')}
                };
                // this.state.active_category_name = item.text;
                this.state.additional_breadcrumb.push(item)
            }
            if (parents.level3) {
                item = null;
                item = {
                    text: parents.level3.name,
                    to: {path: parents.level3.url.replace(new RegExp('\/$'), '')}
                };
                // this.state.active_category_name = item.text;
                this.state.additional_breadcrumb.push(item)
            }
            if (parents.level4) {
                item = null;
                item = {
                    text: parents.level4.name,
                    to: {path: parents.level4.url.replace(new RegExp('\/$'), '')}
                };
                // this.state.active_category_name = item.text;
                this.state.additional_breadcrumb.push(item)
            }
            if (parents.level5) {
                item = null;
                item = {
                    text: parents.level5.name,
                    to: {path: parents.level5.url.replace(new RegExp('\/$'), '')}
                };
                // this.state.active_category_name = item.text;
                this.state.additional_breadcrumb.push(item)
            }
        }

        if (item) {
            let i;
            i = {
                text: item.name,
                to: {path: item.url}
            };
            this.state.active_category_name = i.text;
            this.state.additional_breadcrumb.push(i);

        }

        if (page_name && page_name === 'pages-catalog-new') {
            let i;
            i = {
                text: 'Новинки',
                active: true
            };

            this.state.additional_breadcrumb.push(i)
        }
        this.state.breadcrumb = this.state.breadcrumb_default.concat(this.state.additional_breadcrumb);
    },

    checkMainCategory(category) {
        if (category.parents) {
            this.state.parent_category = category.parents.mainCategory;
        }
    },

    removeBrand(item) {
        let count = 0;
        this.filter.brands.forEach(i => {
            if (i.code == item.code) this.filter.brands.splice(count, 1);
            count++;
        });
        this.getProducts();
    },
    removeCameraType(item) {
        let count = 0;
        this.filter.camera_types.forEach(i => {
            if (i.id == item.id) this.filter.camera_types.splice(count, 1);
            count++;
        });
        this.getProducts();
    },
    removeMatrixSize(item) {
        let count = 0;
        this.filter.matrix_sizes.forEach(i => {
            if (i.id == item.id) this.filter.matrix_sizes.splice(count, 1);
            count++;
        });
        this.getProducts();
    },
    removeLensType(item) {
        let count = 0;
        this.filter.lens_types.forEach(i => {
            if (i.id == item.id) this.filter.lens_types.splice(count, 1);
            count++;
        });
        this.getProducts();
    },
    removeBayonet(item) {
        let count = 0;
        this.filter.bayonets.forEach(i => {
            if (i.id == item.id) this.filter.bayonets.splice(count, 1);
            count++;
        });
        this.getProducts();
    },
    removeMaximumAperture(item) {
        let count = 0;
        this.filter.maximum_apertures.forEach(i => {
            if (i.id == item.id) this.filter.maximum_apertures.splice(count, 1);
            count++;
        });
        this.getProducts();
    },
    removeFocalLength(item) {
        let count = 0;
        this.filter.focal_lengths.forEach(i => {
            if (i.id == item.id) this.filter.focal_lengths.splice(count, 1);
            count++;
        });
        this.getProducts();
    },
    removeCompatibility(item) {
        let count = 0;
        this.filter.compatibilities.forEach(i => {
            if (i.id == item.id) this.filter.compatibilities.splice(count, 1);
            count++;
        });
        this.getProducts();
    },
    removeByTemperature(item) {
        let count = 0;
        this.filter.by_temperatures.forEach(i => {
            if (i.id == item.id) this.filter.by_temperatures.splice(count, 1);
            count++;
        });
        this.getProducts();
    },
    removeLightType(item) {
        let count = 0;
        this.filter.light_types.forEach(i => {
            if (i.id == item.id) this.filter.light_types.splice(count, 1);
            count++;
        });
        this.getProducts();
    },
    removeLED(item) {
        let count = 0;
        this.filter.LEDs.forEach(i => {
            if (i.id == item.id) this.filter.LEDs.splice(count, 1);
            count++;
        });
        this.getProducts();
    },

    resetFilter() {
        console.log('resetFilter');
        this.filter = {
            url: '/catalog',
            page: null,
            price_from: null,
            price_to: null,
            brands: [],
            camera_types: [],
            matrix_sizes: [],
            lens_types: [],
            bayonets: [],
            maximum_apertures: [],
            focal_lengths: [],
            compatibilities: [],
            by_temperatures: [],
            light_types: [],
            LEDs: [],
            sorting: null
        };
        this.show_filter_brand = false;
        this.show_camera_type = false;
        this.show_matrix_size = false;
        this.show_lens_type = false;
        this.show_bayonet = false;
        this.show_maximum_aperture = false;
        this.show_focal_length = false;
        this.show_compatibility = false;
        this.show_by_temperature = false;
        this.show_light_type = false;
        this.show_LED = false;
        //this.getProducts();
    }

}
